import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { PANEL_BANNER_ROUTES, panelBannerResponseSchema } from "@nh/shared";
import { authFetch } from "@/shared/api/session";

/**
 * ═══════════════════════════════════════════════════════════════════
 * El banner de campaña de los dashboards (Anahí, 27-ago): la imagen
 * grande que corona el panel de SOCIO y el de FRANQUICIATARIO, como en
 * el sistema viejo. Se administra en `/admin/banner` (pestaña "Banner
 * del panel"); apagado o sin imagen, este componente no pinta nada.
 *
 * UN componente para los dos paneles: mismo banner, mismo sitio.
 * ═══════════════════════════════════════════════════════════════════
 */
export function PanelBanner() {
  const banner = useQuery({
    queryKey: ["panel-banner"],
    queryFn: async () => {
      const data = await authFetch(PANEL_BANNER_ROUTES.mine, panelBannerResponseSchema, {
        baseUrl: "",
      });
      return data.banner;
    },
    staleTime: 5 * 60_000,
  });

  const data = banner.data;
  if (!data?.enabled || !data.imageUrl) return null;

  const image = (
    <img
      src={data.imageUrl}
      alt={data.alt || ""}
      className="max-h-[340px] w-full rounded-[28px] object-cover shadow-ds-float"
    />
  );

  return (
    <div className="mb-4">
      {data.linkTo ? (
        <Link to={data.linkTo} className="block transition hover:opacity-95">
          {image}
        </Link>
      ) : (
        image
      )}
    </div>
  );
}
